module.exports = __webpack_public_path__ + "static/media/pic_gaojianfasong.0455c895.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/pic_gaojianfasong.svg
// module id = 707
// module chunks = 0